const modifiedFields = ['widgetName','resourceTypeModel','metricModel'];
const modifiedFieldCustom = {};
const sortByFields = {};
export default { modifiedFields, modifiedFieldCustom, sortByFields };